module.exports = __webpack_public_path__ + "quilt3-level4.730710ad.png";